import { Moon, Sun } from "../../../Assets/SVGS";
import { useTranslation } from 'react-i18next'
import darkModeSlice from "../../../zustand/DarkModeSlice";
import './DarkMode.css'

function DarkMode(){
  const { t } = useTranslation();
  const {theme , changeMode} = darkModeSlice()
  return (
    <div className='darkMode-container'>
      <div className='moon-sun-icon' onClick={changeMode}>
        {theme === "dark" ? (
          <div className='sun'>
            <Sun width='20px' />
          </div>
        ) : (
          <div className='moon'>
            <Moon width='20px' />
          </div>
        )}
        <p> 
          {theme==="dark"?t('light'):t('dark')}
        </p>
      </div>
    </div>
  );
}
export default DarkMode